import { isUsingSubscriptionWorkaround } from "../utils";
export class Utils {
    static getBaseUrl() {
        return location.origin;
    }
    static getValueOrDefault(value, defaultValue) {
        if (value !== undefined && value !== null) {
            return value;
        }
        return defaultValue;
    }
    /**
     * Wrapper function to allow stubing in tests
     */
    static isUsingSubscriptionWorkaround() {
        return isUsingSubscriptionWorkaround();
    }
}
export default Utils;
//# sourceMappingURL=Utils.js.map